import React from 'react'
import "./reward.css"

function Reward() {
    return (
        <div className='reward-body'>
            <h3>Award Winning digital <span className='bolder-text'>Marketing Agency</span></h3>
            <p className='text-h6'>Brand's is a digital marketing and SEO company specializing in web and mobile application development with a track record of proven results. </p>
            <img alt='digital' src='../images/awards.jpg' className='image-awards' />
        </div>
    )
}

export default Reward